var _circle, _path, _path2, _rect, _rect2, _rect3, _rect4, _path3, _path4, _path5, _circle2, _circle3, _path6, _ellipse, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPersonReading = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 51,
    viewBox: "0 0 46 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5275,
    cy: 22.5275,
    r: 22.5275,
    fill: "#F8C96A",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4198 10.2543L17.2448 24.3922L23.1485 26.412L34.6453 22.3725V18.4885C34.6453 17.6184 33.9203 17.6081 33.5578 17.7117L34.0239 13.2062L19.4198 10.2543Z",
    fill: "#704402"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1794 13.0506C34.3037 11.5591 32.9883 10.6684 32.3151 10.4094C31.5695 9.16653 30.14 9.16652 29.5184 9.32188C29.1559 9.47724 28.0269 9.50831 26.4112 8.3897C24.3914 6.99143 22.2164 6.36999 20.1967 6.68071C18.5809 6.92929 18.2805 8.54506 18.3323 9.32188C17.8663 9.27009 16.6856 9.29081 15.6913 9.78797C14.4484 10.4094 11.9626 16.7793 18.6432 17.4007C25.3238 18.0222 27.3435 15.0703 29.8293 14.1381C32.3151 13.2059 32.0044 15.5364 32.0044 17.4007C32.0044 18.8922 33.1437 19.1615 33.7134 19.1097C33.8169 17.7114 34.0552 14.5421 34.1794 13.0506Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.0212,
    y: 17.4005,
    width: 4.03942,
    height: 1.2429,
    rx: 0.621449,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27.114,
    y: 17.09,
    width: 6.06586,
    height: 1.2429,
    rx: 0.621449,
    transform: "rotate(3.73304 27.114 17.09)",
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26.1001,
    y: 19.2651,
    width: 4.35015,
    height: 1.55362,
    rx: 0.776812,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18.0212,
    y: 19.2651,
    width: 4.35015,
    height: 1.55362,
    rx: 0.776812,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8295 20.8186C29.8295 20.5301 29.7149 20.0982 29.511 19.8942C29.307 19.6903 29.0304 19.5757 28.742 19.5757C28.4535 19.5757 28.1769 19.6903 27.973 19.8942C27.769 20.0982 27.6544 20.5301 27.6544 20.8186H28.742H29.8295Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7506 20.8186C21.7506 20.5301 21.6361 20.0982 21.4321 19.8942C21.2281 19.6903 20.9515 19.5757 20.6631 19.5757C20.3747 19.5757 20.098 19.6903 19.8941 19.8942C19.6901 20.0982 19.5756 20.5301 19.5756 20.8186H20.6631H21.7506Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4601 18.3329L22.6833 21.7509C22.5279 22.3205 22.559 23.3666 23.9262 22.9938",
    stroke: "black",
    strokeOpacity: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 18.4873,
    cy: 19.7314,
    r: 4.19478,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 28.7418,
    cy: 19.7314,
    r: 4.19478,
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6831 19.2651C22.942 18.8508 23.6774 18.2708 24.5475 19.2651",
    stroke: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.8592,
    cy: 17.8985,
    rx: 0.621449,
    ry: 0.932174,
    transform: "rotate(30.9518 16.8592 17.8985)",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8781 22.6832C25.1823 23.1457 23.6673 24.5475 23.1494 25.3243L39.7732 26.878V18.4884C36.1999 19.7831 28.5871 22.2171 26.8781 22.6832Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4119 23.9257C25.169 24.2986 23.8226 25.0133 23.3047 25.324L41.016 27.1883V19.1095C36.6658 20.5595 27.6548 23.5529 26.4119 23.9257Z",
    fill: "#F1F1F1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7927 19.5757L23.46 25.3241L41.6374 27.4992L41.7927 19.5757Z",
    fill: "#E4E4E4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5304 20.3764L23.3047 23.9697L23.6154 50.3373L39.5477 46.5983C41.8516 46.0577 43.461 43.9759 43.4039 41.6101L42.9382 22.2861C42.9081 21.0373 41.7532 20.1213 40.5304 20.3764Z",
    fill: "#F8C96A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3321 22.5277C21.1388 22.9902 22.7529 24.392 23.3047 25.1688L5.59338 26.7225V18.3329C9.40048 19.6276 17.5113 22.0616 19.3321 22.5277Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7231 23.7708C21.0314 24.1437 22.4488 24.8584 22.9939 25.1691L4.35041 27.0334V18.9546C8.92951 20.4046 18.4148 23.398 19.7231 23.7708Z",
    fill: "#F1F1F1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M3.41854 19.5757L22.6835 25.2114L3.5818 27.3438L3.41854 19.5757Z",
    fill: "#E4E4E4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M4.84877 20.343L23.3047 23.9697L22.9748 50.3373L5.88918 46.5601C3.55204 46.0435 1.90888 43.9429 1.9701 41.5501L2.46379 22.2543C2.49547 21.0162 3.63346 20.1042 4.84877 20.343Z",
    fill: "#F8C96A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3052 22.8386C22.5595 22.8386 21.648 23.2529 21.2855 23.4601V50.027C21.648 50.4413 22.5595 50.8038 23.3052 50.8038C24.051 50.8038 24.9624 50.4413 25.3249 50.027V23.4601C24.9624 23.2529 24.051 22.8386 23.3052 22.8386Z",
    fill: "#E0AF4C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6312 29.858C34.1546 29.787 34.6872 29.8263 35.196 29.9734C35.6262 30.0916 36.0093 30.3449 36.2909 30.6973C36.4609 30.9144 36.5857 31.1644 36.6575 31.432C36.7293 31.6996 36.7467 31.9791 36.7085 32.2533C36.6635 32.634 36.4797 32.9582 36.2514 33.2557C36.0592 33.4915 35.8499 33.7122 35.6252 33.9159C35.463 34.07 35.3056 34.2303 35.1495 34.3938C35.0443 34.5107 34.9703 34.6531 34.9344 34.8076C34.9031 34.9185 34.8725 35.0296 34.8424 35.1409C34.7755 35.4081 34.5926 35.5479 34.3367 35.5956C34.1813 35.6358 34.017 35.6228 33.8692 35.5584C33.7486 35.5005 33.6454 35.4104 33.5707 35.2978C33.4959 35.1852 33.4524 35.0542 33.4447 34.9187C33.4135 34.5846 33.5059 34.2512 33.7036 33.9839C33.92 33.6626 34.2042 33.4045 34.4699 33.1294C34.678 32.9329 34.8498 32.6999 34.9772 32.4415C35.1478 32.0549 35.0097 31.47 34.6135 31.2509C34.4705 31.1723 34.3118 31.1278 34.1497 31.1208C33.902 31.1038 33.6541 31.1481 33.4274 31.2498C33.1646 31.3706 33.014 31.5941 32.9158 31.8617C32.8444 32.0571 32.7836 32.2579 32.6974 32.4467C32.5525 32.7653 32.2584 32.8663 31.9482 32.8465C31.8132 32.8413 31.6826 32.7952 31.5732 32.7141C31.5002 32.6568 31.4401 32.5842 31.3969 32.5013C31.3537 32.4183 31.3285 32.327 31.323 32.2334C31.2892 31.9123 31.3506 31.5887 31.4993 31.3044C31.7486 30.8243 32.138 30.4354 32.614 30.1908C32.9311 30.0201 33.2754 29.9075 33.6312 29.858Z",
    fill: "#E0AF4C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5561 38.0201C35.0168 37.9646 35.3453 37.5463 35.2899 37.0856C35.2344 36.6249 34.816 36.2964 34.3554 36.3519C33.8947 36.4073 33.5662 36.8257 33.6216 37.2864C33.6771 37.747 34.0955 38.0755 34.5561 38.0201Z",
    fill: "#E0AF4C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPersonReading);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/person-reading.21907f0a7e9e01b24a69a262249488ac.svg";